import { defineAction } from '~/prix'
import { z } from 'zod'
import ruralPropertyActivityCreateAction from './ruralPropertyActivityCreate.action.json' with { type: 'json' }
import { ruralPropertyActivityUpsertInputObject } from '../ruralPropertyActivityObject'

const ruralPropertyActivityCreateDefinition = defineAction({
  ...ruralPropertyActivityCreateAction,
  input: ruralPropertyActivityUpsertInputObject,
  output: z.object({
    id: z.string().uuid(),
  }),
})

export default ruralPropertyActivityCreateDefinition
